import { generatePhpArray } from './mixins/permission/covertPhpArray'

const Permissions = {
  backend: {
    name: {
      en: 'Backend',
      km: 'ផ្ទាំងក្រោយ'
    },
    manage: 'manage-backend',
    team: {
      name: {
        en: 'Team',
        km: 'ក្រុម'
      },
      manage: 'manage-team',
      list: 'list-team',
      show: 'show-team',
      store: 'store-team',
      edit: 'edit-team',
      delete: 'delete-team'
    },
    administration: {
      name: {
        en: 'Administration',
        km: 'រដ្ឋបាល'
      },
      manage: 'manage-administration',
      user: {
        name: {
          en: 'User',
          km: 'អ្នកប្រើប្រាស់'
        },
        manage: 'manage-user',
        list: 'list-user',
        show: 'show-user',
        store: 'store-user',
        edit: 'edit-user',
        changePassword: 'change-user-password'
      },
      role: {
        name: {
          en: 'Role',
          km: 'តួនាទី'
        },
        manage: 'manage-role',
        list: 'list-role',
        show: 'show-role',
        store: 'store-role',
        edit: 'edit-role',
        delete: 'delete-role'
      },
      permission: {
        name: {
          en: 'Permission',
          km: 'សិទ្ធិ'
        },
        manage: 'manage-permission',
        list: 'list-permission'
      }
    },
    setting: {
      name: {
        en: 'Settings',
        km: 'ការកំណត់'
      },
      manage: 'manage-setting',
      gender: {
        name: {
          en: 'Gender',
          km: 'ភេទ'
        },
        manage: 'manage-gender',
        list: 'list-gender'
      },
      projectType: {
        name: {
          en: 'Project Type',
          km: 'ប្រភេទគម្រោង'
        },
        manage: 'manage-project-type',
        list: 'list-project-type',
        show: 'show-project-type',
        store: 'store-project-type',
        edit: 'edit-project-type',
        delete: 'delete-project-type'
      },
      position: {
        name: {
          en: 'Position',
          km: 'តួនាទី'
        },
        manage: 'manage-position',
        list: 'list-position',
        show: 'show-position',
        store: 'store-position',
        edit: 'edit-position',
        delete: 'delete-position'
      },
      village: {
        name: {
          en: 'Village',
          km: 'ភូមិ'
        },
        manage: 'manage-village',
        list: 'list-village',
        show: 'show-village',
        store: 'store-village',
        edit: 'edit-village',
        delete: 'delete-village'
      },
      commune: {
        name: {
          en: 'Commune',
          km: 'ឃុំ/សង្កាត់'
        },
        manage: 'manage-commune',
        list: 'list-commune',
        show: 'show-commune',
        store: 'store-commune',
        edit: 'edit-commune',
        delete: 'delete-commune'
      },
      district: {
        name: {
          en: 'District',
          km: 'ស្រុក/ខណ្ឌ'
        },
        manage: 'manage-district',
        list: 'list-district',
        show: 'show-district',
        store: 'store-district',
        edit: 'edit-district',
        delete: 'delete-district'
      },
      province: {
        name: {
          en: 'Province',
          km: 'រាជធានី/ខេត្ត/ក្រុង'
        },
        manage: 'manage-province',
        list: 'list-province',
        show: 'show-province',
        store: 'store-province',
        edit: 'edit-province',
        delete: 'delete-province'
      },
      logsViewer: {
        name: {
          en: 'Logs Viewer',
          km: 'កំណត់ហេតុបញ្ហា'
        },
        manage: 'manage-logs-viewer',
        list: 'list-logs-viewer',
        show: 'show-logs-viewer',
        store: 'store-logs-viewer',
        edit: 'edit-logs-viewer',
        delete: 'delete-logs-viewer'
      }
    }
  }
}

export const copyPermission = () => {
  const textArea = document.createElement('textarea')
  textArea.value = generatePhpArray(Permissions)
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)
}

export default Permissions
